'use client';

import { useRouter } from 'next/navigation';

export default function BackButton() {
  const router = useRouter();

  function handleBack() {
    // Direct landing (push notification, Telegram share, bookmark) has no
    // in-app history — router.back() would close the PWA. Fallback to /dashboard.
    const canGoBack = typeof window !== 'undefined' && window.history.length > 1;
    if (canGoBack) {
      router.back();
    } else {
      router.push('/dashboard');
    }
  }

  return (
    <button
      onClick={handleBack}
      className="inline-flex items-center gap-1 text-sm text-secondary hover:text-primary transition-colors"
    >
      ← Назад
    </button>
  );
}
